<template>
  <div class="basic-layout">
    <div class="sticky-top">
      <Header />
      <top-menu />
    </div>
    <div>
      <child />
    </div>
    <new-order-modal @closeModal="closeNewOrderModal" />
  </div>
</template>

<script>
import Header from '~/components/Header'
import TopMenu from '~/components/common/TopMenu/TopMenu'
import NewOrderModal from '../components/NewOrderModal.vue'
import { mapActions, mapGetters } from 'vuex'
import { isEmpty } from 'lodash'

export default {
  name: 'BasicLayout',
  components: {
    Header,
    TopMenu,
    NewOrderModal
  },
  data () {
    return {
      isShowNewOrderModal: false
    }
  },
  computed: {
    ...mapGetters({
      buildFilterData: 'menus/buildFilterData'
    })
  },

  mounted () {
    if (isEmpty(this.buildFilterData)) {
      this.fetchCommonMenu()
    }
    this.fetchOrders()
  },
  methods: {
    ...mapActions({
      fetchCommonMenu: 'menus/fetchCommonMenu',
      fetchOrders: 'orders/fetchOrders'
    }),
    closeNewOrderModal () {
      this.isShowNewOrderModal = false
      this.$modal.hide('new-order-modal')
    }
  }
}
</script>
